import React, { FC, Fragment, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { formatPriceDynamic } from 'utils/dynamic/dynamic';
import Button from 'components/ui/Button/Button';
import { getCurrency } from 'utils/utils';
import { DynamicContext } from 'contexts/DynamicContext';
import { RoomClass } from 'ts/hotel/interfaces/HotelResponse';
import { Price } from 'ts/hotel/interfaces/HotelDetails';
import { dateFormat } from 'utils/ui';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { b2b } from 'constants/generic';

interface DynamicHotelRoomsProps {
  rooms: RoomClass[];
  showRooms: boolean;
  goToDetails: (room: RoomClass) => void;
  selectedRoomPrice: number;
  numberOfPax: number;
  selectedRoomId?: string;
  onClickChange: (room: RoomClass) => void;
  isLoading?: boolean;
}

const DynamicHotelRooms: FC<DynamicHotelRoomsProps> = (props) => {
  const [t] = useTranslation();
  const { currency } = useContext(DynamicContext);
  return (
    <Fragment>
      {props.showRooms && (
        <div className="hotel-card-rooms">
          <div className="hotel-card-room room-header">
            <div className="pr-5 flex-one">{t('name')}</div>
            <div className="ph-5">{t('hotel.boarding')}</div>
            <div className="ph-10">{t('filter.free_x')}</div>
            <div className="ml-10">{t('dyn.extra_money')}</div>
          </div>
          {props.rooms
            .filter((room) => room.visible)
            .map((room, index) => {
              return (
                <div
                  className={
                    'hotel-card-room' +
                    (new Date(room.cxl.limitDate) < new Date() ? ' room-dyn-cxl' : '')
                  }
                  key={index}
                >
                  <div className="pr-10 flex-one">{room.hotelRooms?.[0].displayName}</div>
                  <div className="ph-5" style={{ marginInlineEnd: 10, marginTop: 7 }}>
                    <div className="room-icon active-meal" style={{ flex: `0 0 34px` }}>
                      {room.board.basis.code !== 'RO' && (
                        <span className="active-meal-i active-i">
                          {['BB', 'HB', 'FB', 'AI', 'M'].includes(room.board.basis.code) &&
                            room.board.basis.code}
                          {room.board.basis.code === 'BB' && <FontAwesomeIcon icon={faCoffee} />}
                          {!['BB', 'RO'].includes(room.board.basis.code) && (
                            <FontAwesomeIcon icon={faUtensils} />
                          )}
                        </span>
                      )}
                      {room.board.basis.code === 'RO' && (
                        <span className="active-meal-i active-i active-meal-i-ro">
                          RO
                          <FontAwesomeIcon icon={faCoffee} />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="ph-10">
                    {new Date(room.cxl.limitDate) < new Date() ? (
                      <span className="color-danger">
                        {b2b ? t('hotel.non_refundable') : t('hotel.full_cancellation_fee')}
                      </span>
                    ) : (
                      <span className="text-success" dir="ltr">
                        {b2b ? '' : t('hotel.free_cancel_before')}{' '}
                        {dateFormat(room.cxl.limitDate, 'dd MMM-yy')}
                      </span>
                    )}
                  </div>
                  <div className="text-bold flex-between ml-10">
                    <span className="flex-center ph-5">
                      {formatPriceDynamic(
                        room.price[currency as keyof Price] / props.numberOfPax -
                          props.selectedRoomPrice,
                        getCurrency(currency)
                      )}
                    </span>
                    <Button
                      disabled={props.isLoading}
                      onClick={() => props.onClickChange(room)}
                      className="btn btn-sm btn-primary"
                      title={t('choose')}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(DynamicHotelRooms, 'DynamicHotelRooms');
